//CLASS
export const CLASS_DAY = 'bnum-card-item-agenda-day';
export const CLASS_HORIZONTAL = 'bnum-card-item-agenda-horizontal';
export const CLASS_BLOCK = 'bnum-card-item-agenda-block';
export const CLASS_HOUR = 'bnum-card-item-agenda-hour';
export const CLASS_VERTICAL = 'bnum-card-item-agenda-vertical';
export const CLASS_TITLE = 'bnum-card-item-agenda-title';
export const CLASS_TITLE_OVERRIDE = 'bnum-card-item-agenda-title-override';
export const CLASS_LOCATION = 'bnum-card-item-agenda-location';
export const CLASS_LOCATION_OVERRIDE =
	'bnum-card-item-agenda-location-override';
export const CLASS_ACTION = 'bnum-card-item-agenda-action';
export const CLASS_ACTION_OVERRIDE = 'bnum-card-item-agenda-action-override';
export const CLASS_PRIVATE_ICON = 'bnum-card-item-agenda-private-icon';
export const CLASS_ALL_DAY = 'bnum-card-item-agenda-all-day';
//ATTRIBUTES
export const ATTRIBUTE_ALL_DAY = 'all-day';
export const ATTRIBUTE_PRIVATE = 'private';
export const ATTRIBUTE_MODE = 'mode';
export const ATTRIBUTE_DATA_TITLE = 'data-title';
export const ATTRIBUTE_DATA_LOCATION = 'data-location';
export const ATTRIBUTE_PENDING = 'agenda_all';
// DATA
export const DATA_DATE = 'date';
export const DATA_DATE_FORMAT = 'date-format';
export const DATA_START_DATE = 'start-date';
export const DATA_START_DATE_FORMAT = 'start-date-format';
export const DATA_END_DATE = 'end-date';
export const DATA_END_DATE_FORMAT = 'end-date-format';
export const DATA_TITLE = 'title';
export const DATA_LOCATION = 'location';
// SLOTS
export const SLOT_TITLE = 'title';
export const SLOT_LOCATION = 'location';
export const SLOT_ACTION = 'action';
// ETATS
export const STATE_ALL_DAY = 'all-day';
export const STATE_PRIVATE = 'private';
export const STATE_MODE_PREFIX = 'mode-';
export const STATE_NO_LOCATION = 'no-location';
export const STATE_ACTION_DEFINED = 'action';
